


























import { editFactory } from '@/main/pages';

import { NdSklad } from '@/modules/sklad/ndSklad';
import { openList } from '@/main/router/routerPath';
import { showAlert } from '@/main/utils/notifications';

import { store } from './store/edit';
import { NAME } from './constants';

import { apiProvider } from './api';

export default editFactory(NAME, store).extend({
	watch: {
		WarningLevel() {
			if ((this.WarningLevel === null ? 0 : this.WarningLevel) < 0 || (this.WarningLevel === null ? 0 : this.WarningLevel) > 100) {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('msgWarningNotMore100Per'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				this.WarningLevel = 0;
			}
		},
		CriticalLevel() {
			if ((this.CriticalLevel === null ? 0 : this.CriticalLevel) < 0 || (this.CriticalLevel === null ? 0 : this.CriticalLevel) > 100) {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('msgCriticalNotMore100Per'),
					options: { type: 'error' },
					localizeMessage: false,
				});
				this.CriticalLevel = 0;
			}
		},
	},

	methods: {
		async deleteClick() {
			try {
				this.startLoading();
				const { data: partAvailabilityResp } = await NdSklad.apiProvider.isPartAvailableInSklad(this.ZbozidruhOzn!);
				if (partAvailabilityResp) {
					showAlert({
						message: this.LocalizeChyboveHlasky('ErrRecDelete'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
					return;
				}
				await apiProvider.deleteEntity(this.ZaznamId!);
				await openList(NAME);
			} catch (error) {
				this.logError(error);
			} finally {
				this.refreshPreviousPage = true;
				this.endLoading();
			}
		},
	},
});
